module.exports = __webpack_public_path__ + "static/media/hm.b63e422b.svg";